// OAuthCallback.js
import { useEffect } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const OAuthCallback = () => {

    const auth = useAuthContext();

    var runExchange = true;

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (runExchange) {
            if (code) {
                exchangeCodeForTokens(code);
            }
            return () => {
                runExchange = false;
            };
        }
    }, []);


    const exchangeCodeForTokens = async (code: string): Promise<void> => {
        // const clientId = process.env.REACT_APP_AMAZON_COGNITO_CLIENT_ID;
        // Use hardcode temporarily
        const clientId = "1kq9a2b4tbn71dbtekh64o8fl";
        const host = window.location.host;
  
        var redirectUri = `https://${host}/oauth2/callback`;

        if (host.includes("localhost")) {
            redirectUri = `http://${host}/oauth2/callback`;
        }
    
        try {
            const response = await fetch(`https://login.skidattl.com/oauth2/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    grant_type: 'authorization_code',
                    client_id: clientId as string,
                    code: code,
                    redirect_uri: redirectUri,
                }).toString(),
            });
    
            if (!response.ok) {
                throw new Error('Failed to exchange code for tokens');
            }
    
            const data: {
                access_token: string;
                id_token: string;
                refresh_token: string;
                token_type: string;
                expires_in: number;
            } = await response.json();

            auth.createCognitoSession(data);
            

        } catch (error) {
            console.error('Error during token exchange:', error);
        }
    };
    
    


    return(
        <>
        <Box sx={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            minHeight: "100vh" 
        }}>
            <CircularProgress />
        </Box>
        </>
    );
};

export default OAuthCallback;
